import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Content from '../components/Common/Content';
import Footer from 'components/Nav/Footer';
// @ts-ignore
import Face from '../assets/face.png';

const HomeIndex = () => {
  return (
    <Box>
      <Content>
        <Box textAlign="center" sx={{ py: { xs: 20, sm: 16, md: 8, lg: 8 } }}>
          <Box component="img" src={Face} sx={{ maxWidth: { xs: '80%', sm: '40%', md: '30%', lg: '25%' } }} />
          <Typography color="primary" variant="h6">
            &lt;404&gt;
          </Typography>
          <Typography color="primary" variant="h6">
            Algo salió mal
          </Typography>
        </Box>
      </Content>
      <Box pt={4} sx={{ px: { xs: 0, sm: 0, md: 0, lg: 15 } }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default HomeIndex;
